import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import PartialTable from 'components/partials/PartialTable';
import { search as searchSection } from 'services/skill-matric-services/smSectionService';
import { search as searchArea } from 'services/skill-matric-services/smAreaService';
import { getMaxtrixUsers } from 'services/userServices';
import './../../../../assets/scss/stickyTable.scss';
import { Link } from 'react-router-dom';
import AppContext from 'context/Context';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const SkillMatrixTable = ({
  data,
  paging,
  total,
  nextPage,
  previousPage,
  gotoPage,
  onPageSizeChange
}) => {
  const {
    config: { isDark }
  } = useContext(AppContext);

  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const sectionsRes = await searchSection({ isGetAll: true });
        const areasRes = await searchArea({ isGetAll: true });
        const usersRes = await getMaxtrixUsers();

        let cls = [
          {
            accessor: 'trainee',
            Header: 'Trainee',
            Cell: rowData => {
              const { trainee } = rowData.row.original;
              const user = usersRes.find(i => i.userId == trainee);
              return user ? user.name : '';
            },
            headerProps: {
              style: {
                backgroundColor: isDark ? 'rgb(34 45 59)' : '#d8e2ef'
              }
            }
          }
        ];

        let cl = generateColumns(sectionsRes.items, areasRes.items);
        cls.push(...cl);
        setColumns(cls);
      } catch (err) {
        console.log(err);
      }
      setLoading(false);
    };

    fetchData();
  }, [isDark]);

  const generateColumns = (sections, areas) => {
    return sections.map(i => {
      return {
        Header: i.name,
        columns: areas
          .filter(a => a.sectionId === i.id)
          .map(a => {
            return {
              accessor: a.id?.toString(),
              _Cell: rowData => {
                const levelNo = rowData.row.original[a.id];
                const status = rowData.row.original[a.id + '_status'];
                const source = rowData.row.original[a.id + '_source'];
                const sourceText = source == 0 ? 'Web' : 'Migrate';
                const { trainee } = rowData.row.original;
                const areaId = a.id;

                const linkStr = `/hr/skill-matrix/section/skills/core-training-record?skillLevelNo=${levelNo}&traineeId=${trainee}&areaId=${areaId}`;

                // status + isDark
                const color =
                  status === 'Inprogress'
                    ? isDark
                      ? '#FF6B6B'
                      : '#D32F2F' // red
                    : status === 'Complete'
                    ? isDark
                      ? '#66FFB3'
                      : '#2E7D32' // green
                    : isDark
                    ? '#FFFFFF'
                    : '#000000'; // default

                return (
                  <Link to={linkStr}>
                    <div className="flex-1">
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`member-${levelNo}`}>
                            {status && <p>Status: {status} </p>}
                            <p>Source : {sourceText}</p>
                          </Tooltip>
                        }
                      >
                        <h6
                          style={{ color, fontSize:'20px' }}
                          className="mb-0"
                        >
                          {levelNo ?? ''}
                        </h6>
                      </OverlayTrigger>
                      {/* <h5 style={{ color }} className="mb-0 fs--1">
              {levelNo ?? ''}
            </h5> */}
                    </div>
                  </Link>
                );
              },
              get Cell() {
                return this._Cell;
              },
              set Cell(value) {
                this._Cell = value;
              },
              Header: (
                <div
                  style={{
                    transform: 'rotate(-45deg)',
                    marginLeft: '15px',
                    marginRight: '15px',
                    marginBottom: '7px',
                    marginTop: '20px',
                    textAlign: 'center',
                    width: '80px',
                    maxWidth: '100px',
                    whiteSpace: 'wrap',
                    color: isDark ? 'white' : '#000000'
                  }}
                >
                  {a.name}
                </div>
              ),
              headerProps: {
                style: {
                  backgroundColor: isDark ? 'rgb(34 45 59)' : '#d8e2ef'
                }
              }
            };
          })
      };
    });
  };
  const tableStyle = {
    border: `1px solid ${isDark ? '#444' : 'black'}`,
    background: isDark ? '#1e1e2f' : 'aliceblue',
    color: isDark ? 'white' : 'black',
    fontWeight: 'bold',
    textAlign: 'center'
  };

  return (
    <div className="sticky-zone skill-matrix">
      <PartialTable
        style={tableStyle}
        option={{ isStickyHeader: true }}
        data={data}
        loading={loading}
        columns={columns}
        paging={paging}
        total={total}
        nextPage={nextPage}
        previousPage={previousPage}
        gotoPage={gotoPage}
        onPageSizeChange={onPageSizeChange}
        textAlign=""
      />
    </div>
  );
};

SkillMatrixTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  paging: PropTypes.object,
  total: PropTypes.number,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  gotoPage: PropTypes.func,
  onPageSizeChange: PropTypes.func
};

export default SkillMatrixTable;
